import { InjectionToken } from '@angular/core';

import { ToastMessageRef } from './toast-message.view-model';

export const TOAST_MESSAGE_REF = new InjectionToken<ToastMessageRef>('ToastMessageRef');
